import classNames from "classnames";
import React, {Fragment} from "react";
import {store} from "src/store";
import {connectAdvanced} from "src/store";
import {bindActionCreators} from "redux";
import {setSelectorImageState} from "../../../actions";
import Icon from "./../Icon";
import PropTypes from "prop-types";
import {Paginator} from "primereact/paginator";
import {MultiSelect} from "primereact/multiselect";
import {Tooltip} from 'react-tippy';
import isEqual from "lodash-es/isEqual";

const styles = {
    grid: {
        icon: {lib: "fa", name: "th-large"},
        name: "Mozaik"
    },
    list: {
        icon: {lib: "fa", name: "th-list"},
        name: "Lista"
    }
}

export const ImageTemplate = (props) => {
    const {image, onSelectionChange, isSelected} = props;
    return <Tooltip title={image.path + image.name}>
        <div onClick={(e) => onSelectionChange(e, image)} className={classNames("image", {active: isSelected(image)}, props.className)} style={{backgroundImage: `url('${image.url}')`}}>
            <img src={image.url} />
            <span className="file">
                <span className="path">{image.path}</span>
                <span className="name">{image.name}</span>
            </span>
        </div>
    </Tooltip>
}

export class DefaultSelectorImage extends React.Component {

    static propTypes = {
        gridid: PropTypes.string,
    }
    
    constructor(props) {
        super(props);
        const stored = props.gridid ? store.getState().selectorimages[props.gridid] : null;
        this.state = (stored && {...stored}) || {
            style: "grid"
        };
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    setPersistenceState = (state, cb) => {
        this.setState(state, () => {
            if (this.props.gridid) {
                this.props.setSelectorImageState(this.props.gridid, this.state);
            }
            cb && cb();
        });
    }

    onPageChange = (params) => {
        this.props.onPage(params);
    }

    onSelectionChange = (e, image) => {
        if (this.props.selectionMode === "single") {
            this.props.onSelectionChange({originalEvent: e, value: image});
        } else {
            let selection = this.props.selection || [];
            if (!selection.find((i) => isEqual(i, image))) {
                selection.push(image);
            }
            this.props.onSelectionChange({originalEvent: e, value: [...selection]});
        }
    }

    isSelected = (image) => {
        if (Array.isArray(this.props.selection)) {
            return !!this.props.selection.find((i) => (i instanceof Object ? i.figure_id : i) + "" === (image instanceof Object ? image.figure_id : image));
        } else if (this.props.selection instanceof Object && image instanceof Object) {
            return this.props.selection.figure_id === image.figure_id;
        } else {
            return (this.props.selection instanceof Object ? this.props.selection.figure_id : this.props.selection) + "" === "" + (image instanceof Object ? image.figure_id : image);
        }
    }

    render() {
        const Container = this.props.containerTemplate || "div";
        const Image = this.props.rowTemplate || ImageTemplate;
        const possibleStyles = Object.keys(styles).map((style) => {
            return {label: styles[style].name, value: style};
        }).filter((el) => el !== undefined && el !== null);
        const currentStyle = this.state.style;
        return <div className={classNames("images", {[currentStyle]: true})}>
            <Container className={classNames("image-list", {empty: !(this.props.value.length && !this.props.loading)})}>
            {
                this.props.value.length && !this.props.loading ?
                    this.props.value.map((image, key) =>
                        <Image key={key} image={image} disabled={this.props.disabled || this.props.loading} onSelectionChange={this.onSelectionChange} isSelected={this.isSelected} />
                    )
                :
                    <div className="empty">{this.props.emptyMessage}</div>
            }
            </Container>
            <Paginator
                first={this.props.paging.first}
                rows={this.props.rows}
                pageLinkSize={this.props.pageLinkSize}
                onPageChange={this.onPageChange}
                template={this.props.paginatorTemplate}
                totalRecords={this.props.totalRecords}
                rowsPerPageOptions={this.props.rowsPerPageOptions}
                currentPageReportTemplate={this.props.currentPageReportTemplate}
                leftContent={
                   this.props.styleSelector === undefined || this.props.styleSelector ? <MultiSelect
                       disabled={this.props.loading}
                       selectedItemTemplate={(style) => <Icon className="p-selected-icon" {...styles[style].icon}/>}
                       value={[currentStyle]}
                       options={possibleStyles}
                       onChange={(e) => {
                           let v = e.value;
                           v = v.filter((value) => value !== currentStyle);
                           v.length !== 0 && this.setPersistenceState({style: v[0]});
                       }}
                   /> : undefined
                }
                rightContent={<Fragment>
                    {this.props.paginatorRight}
                    <button onClick={() => this.props.loadData(true)} type="button"
                            className={classNames("btn btn-default", {disabled: this.props.loading})}
                            disabled={this.props.loading}><Icon lib="fa" name="refresh" spin={this.props.loading} />
                    </button>
                </Fragment>}
                alwaysShow={this.props.alwaysShowPaginator}
            />
        </div>
    }
}

export default class SelectorImage extends React.Component {

    static propTypes = DefaultSelectorImage.propTypes;

    constructor(props) {
        super(props);
        this.Connected = connectAdvanced((dispatch) => {
            return (store, nextOwnProps) => {
                const actions = bindActionCreators({setSelectorImageState}, dispatch);
                return {
                    ...nextOwnProps,
                    ...actions
                }
            }
        },{forwardRef: true})(DefaultSelectorImage);
    }

    refresh = () => {
        this.c && this.c.refresh();
    }

    refreshBackground = () => {
        this.c && this.c.refreshBackground();
    }

    setEditor = (rowIndex, column) => {
        this.c && this.c.setEditor(rowIndex, column);
    }

    render () {
        const Component = this.Connected;
        return <Component ref={(c) => this.c = c} {...this.props}/>;
    }

}